import React, { useEffect } from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { Loader } from '../../../components/Loader/Loader';

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 500,
        width: '100%',
        minWidth: 210,
        '& .MuiButton-containedPrimary': {
            backgroundColor: '#1094F7',
            color: '#ffffff',
            boxShadow: 'none',
            fontWeight: '600',
            fontSize: '18px',
            lineHeight: '21px',
            textTransform: 'none',
            width: '100%',
            borderRadius: '6px',
            minHeight: 60,
            padding: '19.5px 55px',
            [theme.breakpoints.down('xs')]: {
                fontSize: '16px',
                lineHeight: '19px',
                padding: '18.5px 0',
                textAlign: 'center',
            },
        },
        '& .MuiButton-containedPrimary:hover': {
            backgroundColor: '#0E79C9',
            boxShadow: 'none',
        },
        '& .MuiButton-containedPrimary:active': {
            backgroundColor: '#0C6EB8',
            boxShadow: 'none',
        },
        '& .Mui-disabled': {
            backgroundColor: '#87C9FB',
            boxShadow: 'none',
        },
    },
}));

export const ButtonContainer = ({ textButton, disable, needShowLoader, onClick }) => {
    const classes = useStyles();

    useEffect(() => {
        const listener = (e) => {
            if (e.code !== 'Enter' && e.code !== 'NumpadEnter') {
                return;
            }

            const { target } = e;
            if (!(target instanceof Element)) {
                return;
            }

            const listboxOpen = document.querySelector('[role="listbox"]');

            const inCountryInput = target.closest('[data-id="country-input"]');
            const inCityInput = target.closest('[data-id="city-input"]');

            const isRegisterCodeInput = target.getAttribute('data-id') === 'register-code';

            if (listboxOpen || inCountryInput || inCityInput) {
                e.preventDefault();
                return;
            }

            if (isRegisterCodeInput) {
                e.preventDefault();
                if (!disable) {
                    onClick();
                }
                return;
            }

            e.preventDefault();
            if (!disable) {
                onClick();
            }
        };

        document.addEventListener('keydown', listener);
        return () => {
            document.removeEventListener('keydown', listener);
        };
    }, [disable, onClick]);

    return (
        <div className={classes.root}>
            <Button
                variant="contained"
                color="primary"
                disabled={disable}
                onClick={onClick}
                data-id="register-button"
            >
                {needShowLoader ? (
                    <Loader size="smallDot" color="whiteDot" loaderWidth="loaderWidth21" />
                ) : (
                    textButton
                )}
            </Button>
        </div>
    );
};
